<template>
  <q-card style="min-width: 600px">
    <q-toolbar class="bg-primary text-white">
      <q-toolbar-title>{{ $t('delete_account') }}</q-toolbar-title>
      <q-btn flat round dense icon="mdi-close" @click="$emit('close-popup')" />
    </q-toolbar>
    <q-stepper
      v-model="step"
      ref="formAdvertiser"
      color="primary"
      animated
      contracted
      flat
      class="full-width justify-center"
    >
      <q-step class="row q-col-gutter-md full-width justify-center" title="" :name="1">
        <div class="col-12 text-center q-mt-md q-mb-xl text-h5">{{ $t('delete_account_confirmation') }}</div>

        <div class="col-12 row justify-center">
          <q-btn
            color="primary"
            outline
            style="width: 120px"
            class="q-mr-sm q-px-md"
            no-caps
            :label="$t('cancel')"
            unelevated
            @click="$emit('close-popup')"
          />

          <q-btn
            color="negative"
            style="width: 120px"
            class="q-px-md q-ml-sm"
            no-caps
            unelevated
            :label="$t('yes')"
            @click="retrieveAffiliateDataForDeletion"
          />
        </div>
      </q-step>

      <q-step class="row q-col-gutter-md full-width" title="" :name="2">
        <div class="col-12 q-mt-md q-mb-xl text-center text-h6">
          {{
            affiliatePaymentData.paymentInformation
              ? ` ${$t('you_have')} ${parseMoney(affiliatePaymentData.totalComissions)} ${$t('approved_for_payment')}.`
              : `${$t('you_have')} ${parseMoney(
                  affiliatePaymentData.totalComissions
                )} ${$t('approved_for_payment')}. ${$t('to_receive_these_values')}.`
          }}
        </div>

        <div class="col-12 row justify-center">
          <q-btn
            color="primary"
            style="min-width: 120px"
            class="q-mr-sm q-px-md"
            no-caps
            outline
            unelevated
            :label="$t('proceed')"
            @click="() => step++"
          >
            <!-- <q-tooltip content-class="bg-accent" -->
            <!--   >Prosseguir com a exclusão e desistir do recebimento do valor.</q-tooltip -->
            <!-- > -->
          </q-btn>

          <q-btn
            color="positive"
            style="min-width: 120px"
            no-caps
            :label="
              affiliatePaymentData.paymentInformation
                ? $t('request_payment')
                : $t('go_to_payment_information')
            "
            class="q-px-md q-ml-sm"
            unelevated
            @click="affiliatePaymentData.paymentInformation ? askForPayment() : $emit('goToPayment')"
          />
        </div>
      </q-step>

      <q-step class="row q-col-gutter-md full-width" title="" :name="3">
        <div class="col-12 q-my-md text-center pq-mt-md q-mb-xl text-h6">
            {{ $t('by_agreeing_to_the_terms') }}
        </div>

        <div class="col-12 q-my-md text-center pq-mt-md q-mb-xl text-subtitle1">
          <q-list bordered separator class="text-justify">
            <q-item>
              {{ $t('terms_to_delete_account_1') }}:
            </q-item>
            <q-item>
              {{ $t('terms_to_delete_account_2') }}:
            </q-item>
            <q-item>
              {{ $t('terms_to_delete_account_3') }}:
            </q-item>
            <q-item>
              {{ $t('terms_to_delete_account_4') }}:
            </q-item>
            <q-item>
              {{ $t('terms_to_delete_account_5') }}:
            </q-item>
            <q-item>
              {{ $t('terms_to_delete_account_6') }}.
            </q-item>
          </q-list>
        </div>

        <div class="col-12 row justify-center">
          <q-btn
            color="primary"
            style="min-width: 120px"
            class="q-mr-sm q-px-md"
            no-caps
            outline
            unelevated
            :label="$t('accept')"
            @click="() => step++"
          />

          <q-btn
            color="negative"
            style="min-width: 120px"
            no-caps
            :label="$t('refuse')"
            class="q-px-md q-ml-sm"
            unelevated
            @click="$emit('close-popup')"
          />
        </div>
      </q-step>

      <q-step class="row q-col-gutter-md full-width justify-center" title="" :name="4">
        <div class="col-12 text-center q-mt-md q-mb-xl text-h5">{{ $t('confirm_your_credentials_for_deletion') }}</div>

        <q-form @submit="validate" class="col-12 q-pa-md">
          <q-input
            outlined
            bg-color="white"
            type="email"
            v-model="form.username"
            :placeholder="$t('enter_the_email')"
            clearable
            class="rounded"
            clear-icon="close"
            label="Email"
            @keyup.enter="submit"
            lazy-rules
            :rules="[isRequired, isEmail]"
          >
            <template v-slot:prepend>
              <q-icon name="mdi-email-outline" color="primary" />
            </template>
          </q-input>
          <q-input
            clearable
            bg-color="white"
            clear-icon="close"
            outlined
            class="rounded"
            :placeholder="$t('enter_the_pass')"
            v-model="form.password"
            ref="password"
            :label="$t('password')"
            :type="showPassword ? 'text' : 'password'"
            @keyup.enter="submit"
            lazy-rules
            :rules="[isRequired]"
          >
            <template v-slot:prepend>
              <q-icon name="mdi-lock-open-outline" color="primary" />
            </template>
            <template v-slot:append>
              <q-btn
                flat
                round
                color="primary"
                no-caps
                :icon="showPassword ? 'mdi-eye-off-outline' : 'mdi-eye-outline'"
                @click="showPassword = !showPassword"
              />
            </template>
          </q-input>

          <q-btn color="positive" type="submit" unelevated>{{ $t('confirm') }}</q-btn>
        </q-form>
      </q-step>
    </q-stepper>
  </q-card>
</template>

<script>
import AffiliateService from '@/services/AffiliateService';
import AuthService from '@/services/AuthService';

export default {
  name: 'AffiliateAccountExclusionModal',
  mixins: [AffiliateService, AuthService],
  data() {
    return {
      step: 1,
      affiliatePaymentData: {
        totalComissions: 0,
        paymentInformation: false
      },
      form: {
        username: '',
        password: ''
      },
      showPassword: false,
      hasPendingComissions: false
    };
  },
  methods: {
    async retrieveAffiliateDataForDeletion() {
      try {
        this.onLoading(true);
        const { data } = await this.getAffiliateDataForDeletion();
        this.affiliatePaymentData = data;

        if (this.affiliatePaymentData.totalComissions == 0) {
          this.step = 3;
          return;
        }

        this.step = 2;
        this.hasPendingComissions = true;
      } catch (error) {
        this.errorNotify(error);
      } finally {
        this.onLoading(false);
      }
    },

    async askForPayment() {
      try {
        this.onLoading(true);
        const { status } = await this.requestPayment();
        if (status == 200) {
          this.successNotify(
            this.$t('payment_requested_successfully_please_wait_for_processing')
          );
          this.$emit('close-popup');
        }
      } catch (error) {
        this.errorNotify(error);
      } finally {
        this.onLoading(false);
      }
    },

    async validate() {
      var wasValidated = await this.login(this.form);

      try {
        this.onLoading(true);
        if (wasValidated) {
          const { status } = await (this.hasPendingComissions
            ? this.affiliateRequestExclusionNoComission()
            : this.affiliateRequestExclusion());
          if (status == 200) {
            this.successNotify(this.$t('account_deletion_requested_successfully'));
            this.$emit('close-popup');
          }
        }
      } catch (error) {
        this.errorNotify(this.$t('could_not_process_your_request_please_try_again_later'));
      } finally {
        this.onLoading(false);
      }
    },

    async login(form) {
      this.onLoading(true);
      var wasValidated = false;
      try {
        if (!form.username) throw this.$t('validator.required.email');
        if (!form.password) throw this.$t('validator.required.password');
        const { data, status } = await this.authLogin(this.form);
        if (status === 200 && data.login.user.user_id == this.user.user_id) {
          wasValidated = true;
        } else {
          this.errorNotify(this.$t('could_not_confirm_your_credentials_try_again'));
        }
      } catch (error) {
        if (error.response && error.response.status === 500)
          this.errorNotify(this.$t('problem_try_again_later'));
        else this.errorNotify(this.$t('could_not_confirm_your_credentials_try_again'));
      } finally {
        this.onLoading(false);
      }

      return wasValidated;
    }
  }
};
</script>

<style></style>
